import React, { useContext, useState } from "react";
import "./HeroSearch.css";
import DatePicker from "react-datepicker";
import 'react-datepicker/dist/react-datepicker.css'
import { useNavigate } from "react-router-dom";
import { LanguageContext } from "../context/LanguageContext";
import Constants from "../locals/constants.json"


const UpdateDateOut = (InDate, OutDate) => {
  return InDate > OutDate ? OutDate.setDate(InDate.getDate() + 1) : OutDate
}

const HeroSearch = () => {
  const { t, language } = useContext(LanguageContext);

  const today = new Date();
  const tomorrow = (new Date()).setDate(today.getDate() + 1);
  const [selectedDateIn, setSelectedDateIn] = useState(today);
  const [selectedDateOut, setSelectedDateOut] = useState(tomorrow);


  const navigate = useNavigate();

  const handleBookNow = () => {

    navigate(`/${language.value}/booking/currency/eur/checkin/${(new Date(selectedDateIn)).toISOString().split('T')[0]}/checkout/${(new Date(selectedDateOut)).toISOString().split('T')[0]}`);
  };

  return (

    <div id="hero-search" className="hero-search-container">
      <div className="hero-search-input">
        <span
          className="material-symbols-outlined notranslate hero-search-icon">
          calendar_today
        </span>
        <DatePicker
          selected={selectedDateIn}
          wrapperClassName="hero-search-input-datepicker"
          todayButton="Today"
          onChange={(date) => {
            setSelectedDateIn(date);
            setSelectedDateOut((new Date(date)).setDate(date.getDate() + 1));
          }
          }
          dateFormat="dd/MM/yyyy"
          minDate={new Date()}
          className="hero-search-input-field"
          placeholderText="Check-In"
        />
      </div>

      <div className="hero-search-input">
        <span
          className="material-symbols-outlined notranslate hero-search-icon">
          calendar_today
        </span>
        <DatePicker
          placeholderText="Check-Out"
          selected={selectedDateOut}
          wrapperClassName="hero-search-input-datepicker"
          todayButton="Today"
          onChange={(date) => setSelectedDateOut(date)}
          dateFormat="dd/MM/yyyy"
          minDate={(new Date()).setDate(selectedDateIn.getDate() + 1)}
          className="hero-search-input-field"

        />
      </div>
      <div className="hero-search-input">
        <span
          className="material-symbols-outlined notranslate hero-search-icon">
          person
        </span>
        <select
          placeholder={t("hero", "guest")}
          className="hero-search-input-field">
          {Constants.numOfGuests.map(element => (
            <option
              key={element.value}
              value={element.value}>

              {element.label}</option>
          ))
          }
        </select>
      </div>
      <button className="hero-search-button"
        onClick={handleBookNow} >
        {t("hero", "checkAvailability")}
      </button>
    </div>
  );
};

export default HeroSearch;
